import { useState } from "react";
import { Cards } from "../../../components/cards/frame/cards-frame";
import DetailHostConfiguration from "./detailHostConfiguration";
import EditHostConfiguration from "./editHostConfiguration";
import { Button } from "../../../components/buttons/buttons";
import { Link, useLocation } from "react-router-dom";

const HostConfiguration = () => {
    const location = useLocation();
    const [isDetails, setIsDetails] = useState(location?.state?.isdetail ?? true);
    const [topActionButtons, setTopActionButtons] = useState([]);
    const nonDeleteTopActionButtons = topActionButtons.filter((button) => button?.key !== 'delete-host');
    const deleteTopActionButton = topActionButtons.find((button) => button?.key === 'delete-host');

    const handleProfileUpdate = () => {
        setIsDetails(false);
    };
    return (
        <div className="host-config-page">
            {isDetails ? (
                <Cards xs={24} headless className="borderRadius common_fiter_table">
                    <DetailHostConfiguration isDetails={isDetails} setTopActionButtons={setTopActionButtons} />
                </Cards>
            ) : (
                <EditHostConfiguration isDetails={isDetails} setIsDetails={setIsDetails} />
            )}

            <div className="manage-listing-btn host-config-actions">
                {isDetails && (
                    <>
                        {nonDeleteTopActionButtons}
                        {global.checkPermission('host-update') && (
                            <Button
                                className="btn-change-password"
                                key="edit"
                                outlined
                                size="default"
                                shape="circle"
                                type="primary"
                                onClick={handleProfileUpdate}
                            >
                                Edit
                            </Button>
                        )}
                        {deleteTopActionButton}
                    </>
                )}
            </div>
        </div>
    )
}

export default HostConfiguration;   